import { render } from "./ListCategories.vue?vue&type=template&id=19d11900"
import script from "./ListCategories.vue?vue&type=script&lang=js"
export * from "./ListCategories.vue?vue&type=script&lang=js"

import "./ListCategories.vue?vue&type=style&index=0&id=19d11900&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__